import React from 'react';
import Weather from 'components/dynamic-form/custom-elements/weather';

export default ({ input, qaId }) => <Weather input={input} qaId={qaId} component={Weather} />;
